"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shallowProperty = _interopRequireDefault(require("./_shallowProperty.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Internal helper to obtain the `byteLength` property of an object.
var _default = exports.default = (0, _shallowProperty.default)('byteLength');